import { Injectable, inject } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FocusCleanupService {
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => this.clearStrayCaret(), 0);
      });
  }

  private isEditable(el: Element | null): boolean {
    if (!el) return false;
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) return true;
    if (el instanceof HTMLElement && el.isContentEditable) return true;
    return false;
  }

  private clearStrayCaret(): void {
    if (this.isEditable(document.activeElement)) return;

    const sel = typeof window !== 'undefined' && window.getSelection ? window.getSelection() : null;
    if (!sel) return;

    const isCollapsed = sel.type === 'Caret' || (sel.rangeCount === 1 && sel.getRangeAt(0).collapsed);
    if (!isCollapsed) return;
    const anchor = sel.anchorNode;
    if (anchor) {
      let node: Node | null = anchor;
      while (node) {
        if (node instanceof HTMLElement && this.isEditable(node)) {
          return;
        }
        node = node.parentNode;
      }
    }

    try {
      sel.removeAllRanges();
    } catch {
    }
  }
}
